import * as React from "react";
import { Base } from "ui/Scripts/source/framework/base";
import { FileAttachment, IFileAttachment } from "ui/Scripts/source/models/common/fileAttachment";
import { ConfirmationDialogResult, FileType } from "ui/Scripts/source/models/enums";
import { Translations } from "ui/Scripts/source/models/translations";
import { IWhistleBlowEditItemMessage, WhistleBlowEditItemMessage } from "ui/Scripts/source/models/whistleBlow/whistleBlowEditItemMessage";
import { SaveAttachmentBase64 } from "../../../../../../QTeamSystems.QTeamIntra.Ui/Scripts/source/models/common/saveAttachmentBase64";
import { AppUtils } from "../../../framework/appUtils";
import { SaveDataObj } from "../../../framework/saveData";
import * as whistleBlowService from "../../../models/services/whistleBlowService";
import { StoreUtils } from "../../../models/store/storeUtils";
import { NewMessage } from "../../framework/Message/NewMessage";

// WhistleBlowEditDialogMessageListNewAttachmentImage
export interface IWhistleBlowEditDialogMessageListNewAttachmentImageProp {
    attachment: IFileAttachment;
    selectedId: string;
    onClick: (id: string) => void;
    onDropAttachments?: (e: any) => Promise<void>;
    onDragOverAttachments?: (e: any) => void;
    onDragEnterAttachments?: (e: any) => void;
    onDragLeaveAttachments?: (e: any) => void;
}

export class WhistleBlowEditDialogMessageListNewAttachmentImage extends React.Component<IWhistleBlowEditDialogMessageListNewAttachmentImageProp, {}> {
    render() {
        const props = this.props;
        const attachment = props.attachment;
        return (
            <div className={"attachmentImage" + (attachment.id === props.selectedId ? " selected" : "")} onClick={() => { props.onClick(attachment.id); }} title={attachment.name + " (" + Base.intToFileSizeStr(attachment.size, false) + ", " + Base.timeToDateStr(attachment.modifyDate) + ")"}
                onDrop={props.onDropAttachments} onDragOver={props.onDragOverAttachments} onDragEnter={props.onDragEnterAttachments} onDragLeave={props.onDragLeaveAttachments}>
                <img src={attachment.thumbnail} alt={attachment.name} onDrop={props.onDropAttachments} onDragOver={props.onDragOverAttachments} onDragEnter={props.onDragEnterAttachments} onDragLeave={props.onDragLeaveAttachments}/>
            </div>
        );
    }
}

// WhistleBlowEditDialogMessageListNewAttachment
export interface IWhistleBlowEditDialogMessageListNewAttachmentProp {
    attachment: IFileAttachment;
    selectedId: string;
    onClick: (id: string) => void;
    onDropAttachments?: (e: any) => Promise<void>;
    onDragOverAttachments?: (e: any) => void;
    onDragEnterAttachments?: (e: any) => void;
    onDragLeaveAttachments?: (e: any) => void;
}

export class WhistleBlowEditDialogMessageListNewAttachment extends React.Component<IWhistleBlowEditDialogMessageListNewAttachmentProp, {}> {
    render() {
        const props = this.props;
        const attachment = props.attachment;
        return (
            <div className={"attachment" + (attachment.id === props.selectedId ? " selected" : "")} onClick={(e) => { e.stopPropagation(); props.onClick(attachment.id); }} title={attachment.name + " (" + Base.intToFileSizeStr(attachment.size, false) + ", " + Base.timeToDateStr(attachment.modifyDate) + ")"}
                onDrop={props.onDropAttachments} onDragOver={props.onDragOverAttachments} onDragEnter={props.onDragEnterAttachments} onDragLeave={props.onDragLeaveAttachments}>
                <span className={"icon file file_type_" + attachment.type}
                    onDrop={props.onDropAttachments} onDragOver={props.onDragOverAttachments} onDragEnter={props.onDragEnterAttachments} onDragLeave={props.onDragLeaveAttachments}></span>
                <span className="name"
                    onDrop={props.onDropAttachments} onDragOver={props.onDragOverAttachments} onDragEnter={props.onDragEnterAttachments} onDragLeave={props.onDragLeaveAttachments}>{attachment.name + " (" + Base.intToFileSizeStr(attachment.size, false) + ")"}</span>
            </div>
        );
    }
}
// WhistleBlowEditDialogMessageListNew
export interface IWhistleBlowEditDialogMessageListNewProp {
    classes?: string;
    isReadOnly: boolean;
    whistleBlowId: string;
    internalMessages: boolean;
    maxAttachmentsTotalSize: number;
    onSetMessagesContainerMargin: (margin: number) => void;
    onWhistleBlowMessageSaved: (item: IWhistleBlowEditItemMessage) => void;
}

interface IWhistleBlowEditDialogMessageListNewState {
    content: string;
    attachments: FileAttachment[];
    sending: boolean;
}

export class WhistleBlowEditDialogMessageListNew extends React.Component<IWhistleBlowEditDialogMessageListNewProp, IWhistleBlowEditDialogMessageListNewState> {
    private newMessageContainerDiv: HTMLDivElement;
    private attachmentsContainerDiv: HTMLDivElement;
    private attachmentsContainerDivSizeHash: string;
    private attachmentsContainerResizeObserver: ResizeObserver = null;

    constructor(props: IWhistleBlowEditDialogMessageListNewProp) {
        super(props);
        this.state = {
            content: "",
            attachments: [],
            sending: false
        };
    }

    updateAttachmentsContainerSize = Base.debounce((obj: WhistleBlowEditDialogMessageListNew) => {
        if (!obj.newMessageContainerDiv || !obj.attachmentsContainerDiv) return;
        const attachmentsContainerRect = obj.attachmentsContainerDiv.getBoundingClientRect();
        const attachmentsContainerDivSizeHash = attachmentsContainerRect.height.toString(10);
        if (attachmentsContainerDivSizeHash === obj.attachmentsContainerDivSizeHash) return;
        obj.newMessageContainerDiv.style.marginTop = (attachmentsContainerRect.height + 10).toString(10) + "px";
        obj.props.onSetMessagesContainerMargin(-1 * attachmentsContainerRect.height);
        obj.attachmentsContainerDivSizeHash = attachmentsContainerDivSizeHash;
        obj.newMessageContainerDiv.scrollIntoView();
    }, 25);

    updateAttachmentsContainerResizeHandler = (entries) => {
        this.updateAttachmentsContainerSize(this);
    };

    destroyResizeObserver = () => {
        if (!this.attachmentsContainerResizeObserver) return;
        this.attachmentsContainerResizeObserver.disconnect();
        this.attachmentsContainerResizeObserver = null;
    };

    createResizeObserver = () => {
        this.destroyResizeObserver();
        if (this.attachmentsContainerDiv) {
            this.attachmentsContainerResizeObserver = new ResizeObserver(this.updateAttachmentsContainerResizeHandler);
            this.attachmentsContainerResizeObserver.observe(this.attachmentsContainerDiv);
        }
    };

    componentDidMount(): void {
        this.createResizeObserver();
    }

    componentWillUnmount(): void {
        this.destroyResizeObserver();
    }

    getSendingDisabled = (): boolean => {
        const state = this.state;
        return state.sending || !state.content && state.attachments.length < 1;
    };

    getSaveDataFromState = async (props: IWhistleBlowEditDialogMessageListNewProp, state: IWhistleBlowEditDialogMessageListNewState): Promise<SaveDataObj> => {
        const result = new SaveDataObj();
        result.append("whistleBlowId", props.whistleBlowId);
        result.append("content", state.content);
        result.append("internalMessage", props.internalMessages);
        result.append("attachments", await SaveAttachmentBase64.fromFileAttachments(state.attachments));
        return result;
    };

    updateSavedMessageToList = (id: string) => {
        const props = this.props;
        const state = this.state;
        const newMessage = new WhistleBlowEditItemMessage();
        newMessage.id = id;
        newMessage.date = Base.getNowTicks();
        newMessage.content = state.content;
        newMessage.myMessage = true;
        newMessage.isRead = false;
        newMessage.isInternal = props.internalMessages;
        newMessage.modifyUser = StoreUtils.getNowModifyUser();
        newMessage.attachments = state.attachments.slice(0);
        props.onWhistleBlowMessageSaved(newMessage);
    };

    saveWhistleBlowMessage = async () => {
        const props = this.props;
        const state = this.state;
        if (this.getSendingDisabled()) return;
        const confirmation = await AppUtils.showConfirmationDialog(props.internalMessages
            ? Translations.WhistleBlowInternalMessageConfirmation
            : Translations.WhistleBlowInformantMessageConfirmation);
        if (confirmation !== ConfirmationDialogResult.Yes) return;
        if (!props.internalMessages) {
            if (!AppUtils.validateFileAttachments(state.attachments, Translations.MaximumTotalSizeOfAttachmentsIsParameterMB, props.maxAttachmentsTotalSize)) return;
        }
        this.setState({ sending: true });
        try {
            const saveData = await this.getSaveDataFromState(props, state);
            //Call server
            const result = await AppUtils.callService(() => whistleBlowService.whistleBlowEditAddMessage(saveData.obj), false, true);
            if (!result) return null;
            this.updateSavedMessageToList(result.id);
            this.setState({
                content: "",
                attachments: [],
            });
        } finally {
            this.setState({ sending: false });
        }
    };

    // #region Attachments
    checkAttachments = (fileList: FileList): boolean => {
        if (this.props.internalMessages) return true;
        const invalidAttachmentNames: string[] = [];
        for (let i = 0; i < fileList.length; i++) {
            const file = fileList[i];
            if (Base.isNullOrUndefined(file)) continue;
            const fileType: FileType = Base.getFileType(file.name);
            if (fileType !== FileType.Image && fileType !== FileType.Pdf) {
                invalidAttachmentNames.push(file.name);
            }
        }
        if (invalidAttachmentNames.length < 1) return true;
        AppUtils.showErrorMessage(String.format(Translations.OnlyImageAndPdfAttachmentsAreAllowedInvalidAttachmentParamater, invalidAttachmentNames.join(", ")));
        return false;
    };

    handleAddAttachment = async (fileList: FileList) => {
        if (!this.checkAttachments(fileList)) return false;
        const state = this.state;
        const attachments = await FileAttachment.addFileListToFileAttachments(state.attachments, fileList, 0);
        if (attachments.length < 1) return;
        for (const attachment of attachments) {
            if (!AppUtils.validateFileAttachment(attachment, Translations.MaximumSizeOfInstantMessageAttachmentIsParameterMB)) return;
        }
        if (!AppUtils.validateFileAttachments(attachments)) return;
        this.setState({
            attachments
        });
    };

    handleAddAttachments = (newAttachments: FileAttachment[]) => {
        if (!newAttachments || newAttachments.length < 1) return;
        const attachments = this.state.attachments.slice(0);
        for (const newAttachment of newAttachments) {
            if (!newAttachment) return;
            attachments.push(newAttachment);
        }
        if (attachments.length < 1 || !AppUtils.validateFileAttachments(attachments)) return;
        this.setState({
            attachments
        });
    };

    //handleSetAttachmentDropZone = (value: boolean) => {
    //    if (!this.inputElement) return;
    //    if (value) {
    //        this.inputElement.classList.add("draggingOver");
    //    } else {
    //        this.inputElement.classList.remove("draggingOver");
    //    }
    //};

    //handlePasteAttachments = async (e: any) => {
    //    if (!e.clipboardData.files) {
    //        return;
    //    }
    //    const clipboardItems = e.clipboardData.files;
    //    const attachments = this.state.attachments.slice(0);
    //    for (const clipboardItem of clipboardItems) {
    //        const attachment = await this.props.getFileAttachment(clipboardItem, 0);
    //        if (!attachment) return;
    //        attachments.push(attachment);
    //    }
    //    if (attachments.length < 1 || !AppUtils.validateFileAttachments(attachments)) return;
    //    this.setState({
    //        attachments
    //    });
    //};

    handleRemoveAttachment = (id: string) => {
        const state = this.state;
        if (!id) return;
        const attachments = state.attachments.filter(i => i.id !== id);
        this.setState({
            attachments
        });
    };
    // #endregion Attachments

    //# region General
    handleChange = (event) => {
        this.setState({ content: event.target.value });
    };
    // #endregion General

    render() {
        const props = this.props;
        const state = this.state;
        const imageAttachments = state.attachments.filter(i => i.type === FileType.Image);
        const fileAttachments = state.attachments.filter(i => i.type !== FileType.Image);
        return (
            <NewMessage
                message={state.content}
                onChange={(e) => this.handleChange(e)}
                onSend={this.saveWhistleBlowMessage}
                onAddAttachment={this.handleAddAttachment}
                onRemoveAttachment={this.handleRemoveAttachment}
                fileAttachments={fileAttachments}
                imageAttachments={imageAttachments}
                disabled={props.isReadOnly}
                sendDisabled={props.isReadOnly || this.getSendingDisabled()}
                sendButtonTooltip={props.internalMessages ? Translations.SaveMessage : Translations.SendMessage}
            />
        );
    }
}